import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const NavDocument = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M19.355,22.086H4.645c-0.552,0-1-0.448-1-1V2.914c0-0.552,0.448-1,1-1h14.711c0.553,0,1,0.448,1,1\n\t\t    v18.172C20.355,21.638,19.908,22.086,19.355,22.086z M5.645,20.086h12.711V3.914H5.645V20.086z" }),
    React.createElement("rect", { x: "8.105", y: "7.106", width: "7.788", height: "2" }),
    React.createElement("rect", { x: "8.106", y: "10.568", width: "3.893", height: "2" }),
    React.createElement("rect", { x: "8.105", y: "13.894", width: "3.461", height: "2" })), 'NavDocument');
export default NavDocument;
